import { render, staticRenderFns } from "./ContributionsNavigation.vue?vue&type=template&id=b9f29e70&scoped=true"
import script from "./ContributionsNavigation.vue?vue&type=script&lang=ts"
export * from "./ContributionsNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f29e70",
  null
  
)

export default component.exports